import React from 'react';

import { IndeterminateValue, isIndeterminate, PropertySelectField } from '@paragon/client-tools';
import { EnvelopeLabelPlacement, LABEL_PLACEMENTS } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

export function TrussEnvelopeLabelPlacementSelect(props: {
  name?: string;
  disabled?: boolean;

  labelPlacement: EnvelopeLabelPlacement | IndeterminateValue;
  submit: (labelPlacement: EnvelopeLabelPlacement) => void;
}) {
  return (
    <PropertySelectField<EnvelopeLabelPlacement>
      sx={{ margin: 0 }}
      property={props.name ?? 'Label Placement'}
      disabled={props.disabled}
      allowUnknownValues={isIndeterminate(props.labelPlacement)}
      value={props.labelPlacement}
      options={LABEL_PLACEMENTS}
      getName={(placement) =>
        placement === 'CenterLeft' ? 'Center-Left' : placement === 'CenterRight' ? 'Center-Right' : humanCase(placement)
      }
      submit={props.submit}
    />
  );
}
